module.exports = __webpack_public_path__ + "img/profile_credential_011.96ef9037.png";